import React from 'react';
import {useForm} from 'react-hook-form';
import HLButton from "../../shared/components/button/HLButton";
import HLFormInput from "../../shared/components/input/HLFormInput";
import classes from './AuthPage.module.scss';
import {AuthRequest} from "../../shared/types/auth-request";
import {loginRequest} from "../../redux/slices/authSlice";
import {useAppSelector} from "../../shared/hooks/useAppSelector";
import {useAppDispatch} from "../../shared/hooks/useAppDispatch";
import HLErrorMessage from "../../shared/components/error-message/HLErrorMessage";

const AuthPage: React.FC = () => {
  const {loading, error} = useAppSelector(state => state.auth);
  const {register, handleSubmit, formState: {errors, isValid}} = useForm<AuthRequest>({mode: 'onChange'});
  const dispatch = useAppDispatch();

  const login = (request: AuthRequest) => {
    dispatch(loginRequest(request));
  };

  return (
      <div className={classes.authPageContainer}>
        <div className={classes.leftPanel}/>
        <div className={classes.rightPanel}>
          <div className={classes.authFormContainer}>
            <form className={`columnContainer ${classes.authForm}`} onSubmit={handleSubmit(login)}>
              <h2 className={classes.formTitle}>Вход в систему</h2>
              <HLErrorMessage error={error}/>

              <HLFormInput
                  id="login"
                  error={errors.login?.message}
                  {...register('login', {
                    required: 'Это поле обязательное'
                  })}
              >
                Логин
              </HLFormInput>

              <HLFormInput
                  id="password"
                  type="password"
                  autoComplete="new-password"
                  error={errors.password?.message}
                  {...register('password', {
                    required: 'Это поле обязательное'
                  })}
              >
                Пароль
              </HLFormInput>

              <HLButton
                  type="submit"
                  disabled={loading || !isValid}
              >
                {loading ? 'Вход...' : 'Войти'}
              </HLButton>
            </form>
          </div>
        </div>
      </div>
  );
};

export default AuthPage;